import { Users } from 'lucide-react'
import { WorksheetScreen } from '@/components/training/WorksheetScreen'
import type { SheetColumn } from '@/components/training/SheetTable'

/**
 * The "Open Office Hours" tab — an attendance log.
 *
 * The cleanest of the five: four columns, proper date serials, 73 rows across 15
 * organisations and 36 named attendees. Newest first, because it is read from the
 * top rather than scanned as a worklist — the backend orders it that way.
 *
 * No status column, so no row tint and no colour key. Adding one would be
 * decoration.
 */

const columns = (): SheetColumn[] => [
  { key: 'session_date', label: 'Date', kind: 'date', width: 'min-w-[9.5rem]' },
  { key: 'account_name', label: 'CRM account', kind: 'readonly', width: 'min-w-[15rem]' },
  { key: 'organisation_name', label: 'Organisation', kind: 'text', width: 'min-w-[16rem]' },
  { key: 'attendee_name', label: 'Attendee', kind: 'text', width: 'min-w-[13rem]' },
  { key: 'call_notes', label: 'Call notes', kind: 'longtext', width: 'min-w-[26rem]' },
]

export default function TrainingOfficeHours() {
  return (
    <WorksheetScreen
      sheet="office-hours"
      title="Office Hours"
      description="Attendance log for open office hours, most recent first."
      icon={<Users className="h-6 w-6" aria-hidden="true" />}
      columns={columns}
      rowLabel={(r) => String(r.organisation_name ?? r.account_name ?? 'this organisation')}
      caption="Open office hours attendance, most recent session first."
      searchPlaceholder="Search organisation, attendee or notes..."
    />
  )
}
